import axios from 'axios';

import {
    PaginatedQuery,
    PaginatedResult,
} from '@app-types/paginated-query.type';
import { addQueryParams, getAuthToken } from '@services/service';
import { UserSummary } from '@app-types/user.type';

const BASE_URL = process.env.REACT_APP_USERS_URL as string;

const getUsers = async (
    queryParams?: PaginatedQuery & { search?: string }
): Promise<PaginatedResult<UserSummary> | null> => {
    try {
        const inlineParams = addQueryParams(queryParams);
        const response = await axios.get(
            `${BASE_URL}/api/admin/v2/users/${inlineParams}`,
            {
                headers: { Authorization: getAuthToken() },
            }
        );
        return response.data;
    } catch (err) {
        console.error('Error getting users:', err);
        return null;
    }
};

export { getUsers };
